import React from 'react';
import styles from './CrmGrid.module.css';

class GridErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            errorCount: 0,
            lastError: null
        };
        this.resetTimeout = null;
    }

    static getDerivedStateFromError(error) {
        // Check if it's an AG Grid render error that we can safely ignore
        const isAgGridRenderError = error?.message?.includes('cannot get grid to draw rows') ||
                                   error?.message?.includes('getLockOnRefresh');

        if (isAgGridRenderError) {
            // Don't show error UI for known AG Grid timing issues
            // Just suppress the error and continue
            return {
                hasError: false,
                errorCount: 0
            };
        }

        // For other errors, show error UI
        return {
            hasError: true,
            lastError: error?.message || 'Unknown error'
        };
    }

    componentDidCatch(error, errorInfo) {
        // Check if it's an AG Grid render error
        const isAgGridRenderError = error?.message?.includes('cannot get grid to draw rows') ||
                                   error?.message?.includes('getLockOnRefresh');

        if (isAgGridRenderError) {
            // Suppress AG Grid render errors
            // Increment error count but auto-reset after 1 second
            this.setState(prev => ({
                errorCount: prev.errorCount + 1
            }));

            if (this.resetTimeout) {
                clearTimeout(this.resetTimeout);
            }

            this.resetTimeout = setTimeout(() => {
                this.setState({ errorCount: 0 });
            }, 1000);

            // Don't log these errors as they're expected timing issues
            return;
        }

        // For real errors, log them
        console.error('Grid Error:', error, errorInfo);
    }

    componentWillUnmount() {
        if (this.resetTimeout) {
            clearTimeout(this.resetTimeout);
        }
    }

    render() {
        if (this.state.hasError) {
            // Fallback UI for real errors
            return (
                <div className={styles['grid-error-fallback']}>
                    <h3>Grid Error</h3>
                    <p>Something went wrong loading the grid.</p>
                    <p style={{ fontSize: '12px', color: '#666' }}>
                        {this.state.lastError}
                    </p>
                    <button
                        onClick={() => {
                            this.setState({ hasError: false, lastError: null });
                            window.location.reload();
                        }}
                        style={{
                            padding: '8px 16px',
                            marginTop: '16px',
                            cursor: 'pointer'
                        }}
                    >
                        Reload Page
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default GridErrorBoundary;
